<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="action-bar clear">
  <div class="right">
    <button
      type="button"
      class="xrx-btn btn-secondary btn medium glyph xgl-close"
      (click)="activeModal.dismiss()"></button>
  </div>
  <div class="middle">
    <span class="title text-x-large" xdaTranslate>SDE_SELECT_REPOSITORY</span>
  </div>
</div>
<div class="modal-body">
  <div class="scroll-content">
    <div>
      <div class="button-row">
        @for (repo of cloudRepos; track repo) {
          <button
            class="xrx-btn alternative"
            [ngClass]="
              selectedConnector == repo ? 'btn-primary' : 'btn-secondary'
            "
            (click)="activeModal.close(repo)">
            <span [ngClass]="getRepoGlyph(repo.connector)"></span>
            <span class="text-large" [innerHTML]="repo.connector"></span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
